import { FC } from "react";

import classes from "./title.scss";

interface TitleProps {
  title: string;
}

const Title: FC<TitleProps> = ({ title }) => {
  return (
    <div className={classes.root}>
      <h1 className={classes.title} data-t1="product_title" data-t2={title}>
        {title}
      </h1>
    </div>
  );
};

export default Title;
